import { useState, useEffect } from 'react';

const BREAKPOINT = 1024;

export function useBreakpoint(): { isMobile: boolean; isDesktop: boolean } {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return true;
    return window.innerWidth < BREAKPOINT;
  });

  useEffect(() => {
    const mql = window.matchMedia(`(min-width: ${BREAKPOINT}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(!e.matches);
    setIsMobile(!mql.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return { isMobile, isDesktop: !isMobile };
}
